import fitvids from "fitvids";

function videos() {
	fitvids('[data-video]');
}

export default videos;
